import {Component, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, Renderer, ViewChild, OnChanges, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ReservationService} from '../../trip-reservations/reservations.service';

@Component({
  selector: 'app-drop-down-status',
  templateUrl: './drop-down-status.component.html',
  styleUrls: ['./drop-down-status.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DropDownStatusComponent ),
            multi: true
        }
    ]
})
export class DropDownStatusComponent implements OnInit, OnChanges, ControlValueAccessor {
    public tripstatusid: any;
    public statusListArray: any;
    public statusList = [];
    private currentUser = JSON.parse(localStorage.getItem('currentUser'));
   _value = '';

    @Input() allow: any;
    @Input() companyId: any;
    @Input() statusCls: any;
    @Input() hideDropDownArrow: false;
    @Output() emitStatusSelected = new EventEmitter<any>();
    @ViewChild('ddstatus') ddstatus;

    _allowActive: boolean;
    public propagateChange: any  = () => {};
    public constructor(protected service: ReservationService, protected renderer: Renderer, protected element: ElementRef) { }
    ngOnInit() {
        this.loadTripStatus();
    }

    loadTripStatus() {
        this.service.getTripStatus().subscribe(
            data => {
                this.statusListArray = data;
                this.validateStatus();
                this.changeStatusHoldToActive();
            }
        );
    }
    changeStatusHoldToActive() {
        this.statusListArray.map(
            res => {
                if ( res.tripstatusid === '14' ) {
                    res.description = 'Active';
                }
            }
        );
    }
    validateStatus() {

      if (this.currentUser.roleid === 1 || this.currentUser.roleid === 16) {
        this.statusList = this.statusListArray;
      } else {
        const me = this;
        switch (this.tripstatusid) {
            case 1:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if ( this.companyId === 20 ) {
                        if ( item.tripstatusid === 14 || item.tripstatusid === 7 || item.tripstatusid === 1 ) {
                            this.statusList.push(item);
                        }
                    }else {
                        if ( item.tripstatusid === 2 || item.tripstatusid === 7 || item.tripstatusid == 1 ) {
                            this.statusList.push(item);
                        }
                    }
                });
                break;
            case 2:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if (item.tripstatusid === 2 || item.tripstatusid === 1 || item.tripstatusid === 7 || item.tripstatusid === 3) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 14:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if ( item.tripstatusid === 1 || item.tripstatusid === 7 || item.tripstatusid === 14 ) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 3:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if ( item.tripstatusid === 7 || item.tripstatusid === 3 || item.tripstatusid === 2
                        || item.tripstatusid === 5
                    ) {
                        me.statusList.push(item);
                    }
                    if ( item.tripstatusid === 1 && this.companyId === 25 ){
                        me.statusList.push(item);
                    }
                    if ( this.companyId === 19 ) {
                        if ( item.tripstatusid === 9 ) {
                            me.statusList.push(item);
                        }
                    }

                    if (this.currentUser.usertypeid !== 2) {
                        if ( item.tripstatusid === 6 ) {
                            me.statusList.push(item);
                        }
                    }
                });
                break;
            case 16:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if ( item.tripstatusid === 6 || item.tripstatusid === 7 || item.tripstatusid === 10 || item.tripstatusid
                        === 5 || item.tripstatusid === 16 ) {
                        me.statusList.push(item);
                    }
                    /*if(item.tripstatusid==3 && this.companyId==19){
                        me.statusList.push(item);
                    }*/
                });
                break;
            case 5:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if ( item.tripstatusid === 6 || item.tripstatusid === 7 || item.tripstatusid === 10 || item.tripstatusid === 5 ) {
                        me.statusList.push(item);
                    }
                    if (item.tripstatusid == 3 && this.companyId == 19 ) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 6:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if (item.tripstatusid === 2 || item.tripstatusid === 6 ) {
                        if (item.tripstatusid === 2) {
                            item.description = 'Reactive';
                        }
                        me.statusList.push(item);
                    }
                });
                break;
            case 7:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if (item.tripstatusid === 7 || item.tripstatusid === 1 ) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 9:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if (item.tripstatusid === 2 || item.tripstatusid === 9 ) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 10:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if ( item.tripstatusid === 11 || item.tripstatusid === 12 || item.tripstatusid === 10 || item.tripstatusid === 7) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 11:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if (item.tripstatusid === 12 || item.tripstatusid === 11 ) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 12:
                this.statusList = [];
                this.statusListArray.map((item) => {
                    if ( item.tripstatusid === 8 || item.tripstatusid === 12 ) {
                        me.statusList.push(item);
                    }
                });
                break;
            case 15:
              this.statusList = [];
              this.statusListArray.map((item) => {
                if ( item.tripstatusid === 7 || item.tripstatusid === 6 || item.tripstatusid === 1 || item.tripstatusid === 2) {
                  me.statusList.push(item);
                }
              });
              break;
          }
      }

      this.allowedStates();
    }

    allowedStates() {
      if (Array.isArray(this.allow)) {
        this._allowActive = true;
        this.statusList.map((element) => {
          element.disabled = this.allow.indexOf(element.tripstatusid) === -1;
        });
      }
    }

    writeValue( value: any ) {
        if (value) {
            this.tripstatusid = value;
        }
    }

    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: () => void ) : void {};

    onSelectStatus(event) {
        this.emitStatusSelected.emit(event);
        this.propagateChange(event);
    }

    setDisabledState(isDisabled: boolean) {
        this.renderer.setElementProperty(this.ddstatus.nativeElement, 'disabled', isDisabled);
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes['allow']) {
        if (changes['allow'].currentValue) {
          this.allowedStates();
        }
      }
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/drop-down-status/drop-down-status.component.ts